import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle, XCircle } from 'lucide-react';
export function TargetAudienceSection() {
  return <section className="py-20 px-6 bg-white" data-id="element-139">
      <div className="max-w-4xl mx-auto" data-id="element-140">
        <FadeIn data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-142">
            ¿Para quién es este protocolo?
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-143">
            <div className="bg-green-50 rounded-3xl p-8 border-2 border-green-200" data-id="element-144">
              <div className="flex items-center gap-4 mb-6" data-id="element-145">
                <CheckCircle className="w-10 h-10 text-forest" data-id="element-146" />
                <h3 className="text-2xl font-bold text-forest" data-id="element-147">
                  SÍ ES PARA TI
                </h3>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-148">
                Para quienes tienen creatinina alta, diagnóstico preventivo,
                diabetes, hipertensión o síntomas de fatiga renal.
              </p>
            </div>

            <div className="bg-red-50 rounded-3xl p-8 border-2 border-red-200" data-id="element-149">
              <div className="flex items-center gap-4 mb-6" data-id="element-150">
                <XCircle className="w-10 h-10 text-red-500" data-id="element-151" />
                <h3 className="text-2xl font-bold text-red-700" data-id="element-152">
                  NO ES PARA TI
                </h3>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-153">
                Para personas en etapa de diálisis avanzada o emergencias
                médicas de hospital.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}